const DEFAULT_FONT_SIZE = 36;
const DEFAULT_MAX_LINE_WIDTH = 760;

function escapeXml(value) {
  return String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&apos;");
}

function estimateTextWidth(value, fontSize) {
  return Array.from(String(value || "")).reduce((width, character) => {
    if (/\s/.test(character)) return width + fontSize * 0.32;
    if (/[ilI1.,:;!'|]/.test(character)) return width + fontSize * 0.3;
    if (/[mwMW@#%&]/.test(character)) return width + fontSize * 0.86;
    return width + fontSize * 0.58;
  }, 0);
}

function wrapLine(line, fontSize, maxLineWidth) {
  if (!line) return [""];
  const words = String(line).split(/(\s+)/).filter(Boolean);
  const lines = [];
  let current = "";

  words.forEach((word) => {
    const candidate = `${current}${word}`;
    if (current.trim() && estimateTextWidth(candidate, fontSize) > maxLineWidth) {
      lines.push(current.trimEnd());
      current = word.trimStart();
    } else {
      current = candidate;
    }
  });

  if (current || !lines.length) lines.push(current.trimEnd());
  return lines;
}

export function getTextWidgetLayout(text, options = {}) {
  const fontSize = Math.max(12, Number(options.fontSize || DEFAULT_FONT_SIZE));
  const maxLineWidth = Math.max(180, Number(options.maxLineWidth || DEFAULT_MAX_LINE_WIDTH));
  const paddingX = Math.max(8, Math.round(fontSize * 0.34));
  const paddingY = Math.max(8, Math.round(fontSize * 0.3));
  const lineHeight = Math.round(fontSize * 1.28);
  const sourceLines = String(text || "").replace(/\r\n?/g, "\n").split("\n");
  const lines = sourceLines.flatMap((line) => wrapLine(line, fontSize, maxLineWidth));
  const contentWidth = Math.max(fontSize * 2, ...lines.map((line) => estimateTextWidth(line, fontSize)));

  return {
    fontSize,
    lineHeight,
    paddingX,
    paddingY,
    lines,
    svgWidth: Math.ceil(contentWidth + paddingX * 2),
    svgHeight: Math.ceil(lines.length * lineHeight + paddingY * 2),
  };
}

export function createTextWidgetSvgDataUrl({
  text,
  color = "#f8fafc",
  fontSize = DEFAULT_FONT_SIZE,
  fontWeight = 400,
} = {}) {
  const layout = getTextWidgetLayout(text, { fontSize });
  const safeFontWeight = Math.max(300, Math.min(900, Math.round(Number(fontWeight || 400) / 100) * 100));
  const tspans = layout.lines.map((line, index) => (
    `<tspan x="${layout.paddingX}" y="${layout.paddingY + layout.fontSize + index * layout.lineHeight}">${escapeXml(line || " ")}</tspan>`
  )).join("");
  const svg = [
    `<svg xmlns="http://www.w3.org/2000/svg" width="${layout.svgWidth}" height="${layout.svgHeight}" viewBox="0 0 ${layout.svgWidth} ${layout.svgHeight}">`,
    `<text fill="${escapeXml(color)}" font-family="Rubik, Arial, sans-serif" font-size="${layout.fontSize}" font-weight="${safeFontWeight}">`,
    tspans,
    "</text></svg>",
  ].join("");

  return {
    src: `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`,
    layout,
  };
}
